import React from 'react';

import autoBind from 'react-autobind';
import Config from "composer/Config.jsx";

// import other components within the same project here

import LoginDialog from "composer/views/LoginDialog.jsx";
import ForgetPasswordDialog from "composer/views/ForgetPasswordDialog.jsx";
import AgreementDialog from "composer/views/AgreementDialog.jsx"
import AccountDisabledDialog from 'composer/views/AccountDisabledDialog';

import {
  grey,
} from '@material-ui/core/colors'

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      forgetPasswordDialogOpen: false,
      agreementDialogOpen: false,
      loginResult: null,
      latestAgreementVersion: 0,
      agreemenText: "",
    };
    autoBind(this);

    this.fetchAgreement();
  }

  fetchAgreement() {
    fetch(Config.AGREEMENT_URL())
      .then((resp)=>{ return resp.text() })
      .then((text)=>{
        let parser = new DOMParser();
        let doc = parser.parseFromString(text, 'text/html');
        let content = doc.querySelector('#content').innerHTML;
        this.setState({ agreemenText: content });
        this.state.agreemenText = content;
      })
      .catch(function (err) {
        console.log("failed to load agreement");
      });
  }

  loginOK(res) {
    this.setState({loginResult: res});
    this.state.loginResult = res;

    if (res['latest_agreement_version'] != null) {
      let agreement_version = parseInt(res['latest_agreement_version']);
      this.setState({ latestAgreementVersion: agreement_version });
      this.state.latestAgreementVersion = agreement_version;
    }

    // check account disabling here
    let account_disable_level = Math.max(parseInt(res['user_disabled']), parseInt(res['school_disabled']));
    
    if(account_disable_level != 0){
      this.refs.accountDisabledDialog.setState({ open: true });
      this.refs.accountDisabledDialog.state.open = true;
      this.refs.accountDisabledDialog.setState({ account_disable_level: account_disable_level });
      this.refs.accountDisabledDialog.state.account_disable_level = account_disable_level;
      return;
    }

    if (parseInt(res['has_read_tac']) < this.state.latestAgreementVersion) {
      this.showAgreement();
    }
    else {
      this.agreementAccepted();
    }
  }

  agreementAccepted() {
    this.props.root.loginOK(this.state.loginResult);
  }

  forgetPasswordClicked() {
    this.setState({forgetPasswordDialogOpen: true});
    this.state.forgetPasswordDialogOpen = true;
  }

  showAgreement() {
    this.setState({agreementDialogOpen: true});
    this.state.agreementDialogOpen = true;
  }

  render() {
    return (
      <div style={{position:"fixed", backgroundColor:grey[200], width:"100%", height:"100%", top:0, left:0, bottom:0, right:0}}>
        <LoginDialog root={this.props.root} parent={this} ref="loginDialog"/>
        <ForgetPasswordDialog parent={this} root={this.props.root} ref="forgetPasswordDialog"/>
        <AgreementDialog root={this.props.root} parent={this} ref="agreementDialog"/>
        <AccountDisabledDialog root={this.props.root} parent={this} ref="accountDisabledDialog"/>
      </div>
    )
  }
}

export default LoginPage;
